export default "__VITE_ASSET__BnU2IJKB__"